import { WishlistItemSchema } from "@apps/wishlist/schemas/WishlistItemSchema";
import { object } from "superstruct";

export const DeleteItemResponseSchema = object({
    deletedItem: WishlistItemSchema,
});
